import { render } from "./FormLocalitiesWithDealer.vue?vue&type=template&id=7a20bd3f&ts=true"
import script from "./FormLocalitiesWithDealer.vue?vue&type=script&lang=ts"
export * from "./FormLocalitiesWithDealer.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__